import React from 'react';
import { func, bool, string, number } from 'prop-types';
import classNames from 'classnames';

import { IconArrowHead } from '../../components';
import css from './AmenityCategoryHeader.module.css';

const AmenityCategoryHeader = props => {
  const { categoryName, selectedCount, isExpanded, onClick, className, rootClassName } = props;

  const classes = classNames(rootClassName || css.root, className);

  const selectionText = `${selectedCount} selected`;

  return (
    <button type="button" className={classes} onClick={onClick}>
      <div className={css.content}>
        <span className={css.categoryName}>{categoryName}</span>
        <span className={css.selectionCount}>{selectionText}</span>
      </div>
      <div className={classNames(css.chevron, { [css.chevronExpanded]: isExpanded })}>
  <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.55307 8.13421L1.28852 0.87941C1.21799 0.80851 1.13396 0.75249 1.04139 0.71467C0.948824 0.67684 0.849607 0.65797 0.749618 0.65918C0.649628 0.6604 0.550898 0.68166 0.459276 0.72172C0.367653 0.76178 0.285004 0.81982 0.216217 0.8924C0.0752906 1.04086 -0.00219163 1.23842 0.0002345 1.44311C0.00266254 1.64779 0.0848063 1.84346 0.229214 1.98853L8.031 9.77949C8.101 9.84997 8.18435 9.90578 8.27618 9.94368C8.36801 9.98157 8.46647 10.0008 8.5658 10.0002C8.66514 9.99956 8.76336 9.97916 8.85472 9.94015C8.94608 9.90114 9.02874 9.84432 9.09788 9.77299L17.1076 1.57261C17.2494 1.42581 17.3286 1.2297 17.3286 1.02563C17.3286 0.82156 17.2494 0.62545 17.1076 0.47865C17.038 0.40692 16.9546 0.3499 16.8625 0.31096C16.7704 0.27202 16.6715 0.25195 16.5715 0.25195C16.4715 0.25195 16.3725 0.27202 16.2804 0.31096C16.1883 0.3499 16.105 0.40692 16.0353 0.47865L8.55307 8.13421Z" fill="black"/>
</svg>

      </div>
    </button>
  );
};

AmenityCategoryHeader.defaultProps = {
  isExpanded: false,
  className: null,
  rootClassName: null,
};

AmenityCategoryHeader.propTypes = {
  categoryName: string.isRequired,
  selectedCount: number.isRequired,
  isExpanded: bool,
  onClick: func.isRequired,
  className: string,
  rootClassName: string,
};

export default AmenityCategoryHeader;
